module.exports = __webpack_public_path__ + "14four/static/media/FT-Icon.327baea5.svg";